<template>
  <div class="container-supplier">
    <el-tooltip effect="dark" content="新建" placement="top">
      <svg-icon icon-class="New" className="icon-new" @click="create"/>
    </el-tooltip>

    <!--列表显示新增项目-->
    <el-row>
    <el-col :span="24">
    <el-card shadow="always" body-style="text-align:center;padding:0px;" id='tableCard'>
      <el-table :data="items" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" id="TableOutPut" height='calc(100vh - 133px)'  :row-style="{height:'45px'}"  border stripe :header-cell-style="headerStyle">
        <el-table-column type="index" label="行号" width="55" align="center"></el-table-column>
        <el-table-column prop="cloudPlatform" label="模型平台" align="center" min-width="80"  :formatter="calcPlatform"></el-table-column>
        <el-table-column prop="apiKey" label="apiKey" align="center" min-width="130"></el-table-column>
        <el-table-column prop="baseURL" label="baseURL" align="center" min-width="100"></el-table-column>
        <el-table-column prop="PlatformURL" label="控制台URL" align="center" min-width="100">
          <template slot-scope="scope">
            <el-tag type="success" plain @click="openURL(scope.row.PlatformURL)">{{ scope.row.PlatformURL }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="PlatformURL" label="启用" align="center" min-width="70">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isEnable?'success':'danger'" plain>{{ scope.row.isEnable?'是':'否' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div style="display: flex;flex-flow: row nowrap;justify-content: center;align-items: center;">
              <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <svg-icon icon-class="Edit" class="icon-edit-class" @click="edit(scope.row)"/>
              </el-tooltip>
              <el-divider direction="vertical" class="divider"></el-divider>
              <el-tooltip class="item" effect="dark" content="删除" placement="top">
                <svg-icon icon-class="Delete" class="icon-delete-class" @click="removeItem(scope.$index)"/>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    </el-col>
    </el-row>
  </div>
</template>
<script>
import editDialog from './Editor/index.js'
export default {
  data() {
    return {
      id:'',
      items: []
    };
  },
  methods: {
    async create() {
      editDialog(this.id,null,this.fetch)
    },
    async edit(row) {
      editDialog(this.id,row,this.fetch)
    },
    async fetch() {
      const res=await this.$http.get(`/setting/systemInfo/openai`)
      if(res.data){
        this.items=res.data.arr
        this.id=res.data.id        
      }
    },
    async removeItem(index){
      this.$confirm('确认是否删除该项','提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: "warning",
      }).then(async () => {
          this.items.splice(index,1)
          await this.$http.delete(`/setting/systemInfo/openai/${this.id}`,{data:this.items})
          this.$message({
            type: "success",
            message: '删除成功',
          });
          this.fetch()
        }).catch((err) => {
          console.log(err);
        });
    },
    openURL(url){
      window.open(url)
    },
    calcPlatform(row, column, cellValue, index){
      if(cellValue=='kimi'){
        return '月之暗面'
      }else{
        return '通义千问'
      }
    }
  },
  created(){
    this.fetch()
  }
};
</script>
<style scoped>
.icon-new {
  font-size:24px;
  color: orange;
  cursor: pointer;
  position: fixed;
  top:95px;
  right:20px;
}
#tableCard >>>.el-table .cell{
  line-height: 1.3!important;
  padding: 0!important;
  white-space:pre-wrap;
}
.el-table .cell p{
  margin: 0!important;
}
#tableCard >>>.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fad8bca4!important;
  cursor: pointer;
}
#tableCard >>>.el-table__body tr.current-row > td {
  background-color: #c6e4f8b4 !important;
  cursor: pointer;
}
</style>

